import React, { useState, useEffect } from "react";
import "./OnionBuy.css"; // Reuse the existing CSS or create a new one as per your need
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";
import Whyglobal from "../Components/Whyglobal";

// Sample random data for tape buyers
const TapeBuys = [
  {
    _id: "66869a299f2cecbc7cc11482",
    name: "Rajput Rakesh Rana",
    email: "rakeshrana@email.com",
    mobileNumber: "8628831897",
    lookingFor: "Looking for bulk tape supplies for construction site.",
    location: "Shahpur",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: "Bulk",
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11483",
    name: "Aarisha S",
    email: "aarishas@email.com",
    mobileNumber: "9667652549",
    lookingFor: "Need contact urgently for tape product inquiry.",
    location: "Churu",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: "Bulk",
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11484",
    name: "H. M Khandelwal",
    email: "khandelwalhm@email.com",
    mobileNumber: "9958092440",
    lookingFor: "Marketing manager seeking tape vendors for distribution.",
    location: "Delhi",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: "Bulk",
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11485",
    name: "Muzammil Khan",
    email: "muzammilk@email.com",
    mobileNumber: "9063148013",
    lookingFor: "Urgent requirement of 50 tapes for packaging.",
    location: "Mudivedu",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: 50,
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11486",
    name: "Pawan Durga",
    email: "pawandurga@email.com",
    mobileNumber: "8922058531",
    lookingFor: "Looking for branded tapes for industrial use.",
    location: "Pgiut",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: "Bulk",
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11487",
    name: "Hemant Chaudhari",
    email: "hemantchaudhari@email.com",
    mobileNumber: "8806201055",
    lookingFor: "Required 600 units of adhesive tapes urgently.",
    location: "Dhule",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: 600,
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11488",
    name: "Hitesh Joshi",
    email: "hiteshjoshi@email.com",
    mobileNumber: "9929990204",
    lookingFor: "In need of 1000 tapes for packaging warehouse.",
    location: "Nathdwara",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: 1000,
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11489",
    name: "Er Akshay Hariom",
    email: "akshayhariom@email.com",
    mobileNumber: "6299551321",
    lookingFor: "Need 500 tape pieces for factory supply.",
    location: "Barbigha",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: 500,
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11490",
    name: "Jafar Ali Jafar Ali",
    email: "jafarali@email.com",
    mobileNumber: "9894358611",
    lookingFor: "Please share address and phone for urgent tape purchase.",
    location: "Thiruvarur district kodavasan",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: "Bulk",
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11491",
    name: "KRISHNAM GOEL",
    email: "krishnamgoel@email.com",
    mobileNumber: "7009379004",
    lookingFor: "Urgently require 1000 tape rolls for industrial use.",
    location: "Amritsar",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: 1000,
    unit: "pcs",
  },
  {
    _id: "66869a299f2cecbc7cc11492",
    name: "Yogiraj Patil",
    email: "yogirajpatil@email.com",
    mobileNumber: "9545156151",
    lookingFor: "Looking to take dealership for tapes in Parbhani.",
    location: "Parbhani",
    date: "07-04-2025",
    productOrService: "Tape",
    quantity: "Bulk",
    unit: "pcs",
  },
  {
    _id: "86901a299f2cecbc7cc11463",
    name: "Rohit Sharma",
    email: "rohit.sharma@gmail.com",
    mobileNumber: "9012345678",
    lookingFor: "Bulk Order for Duct Tape",
    location: "Delhi",
    date: "11-03-2025",
    productOrService: "Tape Supplier",
    quantity: 2000,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11464",
    name: "Priya Singh",
    email: "priya.singh@gmail.com",
    mobileNumber: "9023456789",
    lookingFor: "Custom Printed Tape Supplier Needed",
    location: "Pune",
    date: "11-03-2025",
    productOrService: "Printed Tape Dealer",
    quantity: 800,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11465",
    name: "Vikas Patel",
    email: "vikas.patel@gmail.com",
    mobileNumber: "9934567890",
    lookingFor: "Colored Masking Tape for Arts",
    location: "Ahmedabad",
    date: "10-03-2025",
    productOrService: "Masking Tape Supplier",
    quantity: 600,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11466",
    name: "Kavita Mehta",
    email: "kavita.mehta@gmail.com",
    mobileNumber: "9123456789",
    lookingFor: "Looking for Heat Resistant Tape",
    location: "Hyderabad",
    date: "10-03-2025",
    productOrService: "Industrial Tape Supplier",
    quantity: 1200,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11467",
    name: "Anil Kumar",
    email: "anil.kumar@gmail.com",
    mobileNumber: "9321654789",
    lookingFor: "Bulk Double-Sided Foam Tape",
    location: "Chennai",
    date: "09-03-2025",
    productOrService: "Foam Tape Distributor",
    quantity: 900,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11468",
    name: "Sneha Chatterjee",
    email: "sneha.chatterjee@gmail.com",
    mobileNumber: "9871234560",
    lookingFor: "Anti-Slip Tape in Large Quantity",
    location: "Jaipur",
    date: "26-10-2024",
    productOrService: "Safety Tape Supplier",
    quantity: 700,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11460",
    name: "Amit Verma",
    email: "amit.verma@gmail.com",
    mobileNumber: "9876543211",
    lookingFor: "Buying: Masking Tape in Bulk",
    location: "Mumbai",
    date: "17-10-2024",
    productOrService: "Tape Supplier",
    quantity: 1000,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11461",
    name: "Neha Jain",
    email: "neha.jain@gmail.com",
    mobileNumber: "9987654311",
    lookingFor: "Need Double-sided Adhesive Tape",
    location: "Bangalore",
    date: "16-10-2024",
    productOrService: "Adhesive Tape Dealer",
    quantity: 500,
    unit: "rolls",
  },
  {
    _id: "86901a299f2cecbc7cc11462",
    name: "Manoj Gupta",
    email: "manoj.gupta@gmail.com",
    mobileNumber: "9123456781",
    lookingFor: "Transparent Tape Urgently Required",
    location: "Kolkata",
    date: "15-10-2024",
    productOrService: "Packaging Tape Wholesaler",
    quantity: 1500,
    unit: "rolls",
  },
];

const TapeBuy = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;

    // Load the viewed leads from local storage
    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`tapeViewedLeads_${userId}`)) || [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
        console.log("Premium Status:", data.isPremium);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      });
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return; // Only premium users can see numbers

    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }

    if (shownNumbers.includes(index)) return; // If already shown, do nothing

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);

    // Update local storage
    localStorage.setItem(
      `tapeViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = TapeBuys[index]; // Get the buyer information

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (error) {
      console.error("Error incrementing leads viewed:", error.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item"
          >
            <Link to={"/"}>Home</Link>
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px -25px",
            }}
          >
            /
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item active"
          >
            Fresh Leads
          </li>
        </ol>
      </div>
      <div className="containersx">
        <div style={{ width: "200px", padding: "10px" }} className="browsers">
          <h3 style={{ marginTop: "30px" }}>Browse by State</h3>
          <ul className="flt-list cust-scroll" id="state-lists">
            <li>
              <Link to="#">All India</Link>
            </li>
            <li>
              <Link to="#">Delhi</Link>
            </li>
            <li>
              <Link to="#">Maharashtra</Link>
            </li>
            <li>
              <Link to="#">Gujarat</Link>
            </li>
            <li>
              <Link to="#">Karnataka</Link>
            </li>
            <li>
              <Link to="#">West Bengal</Link>
            </li>
          </ul>

          <ul style={{ marginTop: "20px" }} className="flt-list cust-scroll">
            <h3>All Category</h3>
            <li>
              <Link to="#">Masking Tape</Link>
            </li>
            <li>
              <Link to="#">Adhesive Tape</Link>
            </li>
            <li>
              <Link to="#">Transparent Tape</Link>
            </li>
            <li>
              <Link to="#">Duct Tape</Link>
            </li>
            <li>
              <Link to="#">Packaging Tape</Link>
            </li>
          </ul>
        </div>
        <div className="buyers">
          {TapeBuys.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "red" }}>{buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Location:</strong> {buyer.location}
              </p>
              <p>
                <strong>Date:</strong> {buyer.date}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                {userIsPremium && (
                  <button
                    className="detail-btn"
                    style={{
                      padding: "5px 10px",
                      background: "#f7f1f1",
                      color: "orange",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleNumber(index)}
                  >
                    Click to see
                  </button>
                )}
              </div>
              <div className="btns-imp">
                <Link to={"/login"}>
                  <button className="detailing-btn">View More</button>
                </Link>
                <Link to={"/register-Company"}>
                  <button className="regis-btn">Register Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="sidebar">
          <div className="mains-slide">
            <div className="tk23-hkCont_onergt">
              <div className="tk23-hkCont_premserv__box">
                <h1 className="tk23-hkCont_premserv__ttl">
                  Our Membership Plans
                </h1>
                <div class="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div class="tk23-hkCont_premservs">
                      <span class="fontss" style={{ backgroundColor: "#fff" }}>
                        Standard Plan
                      </span>
                    </div>
                  </Link>
                </div>
                <div class="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div class="tk23-hkCont_premservs">
                      <span class="fontss" style={{ backgroundColor: "#fff" }}>
                        Advance Plan
                      </span>
                    </div>
                  </Link>
                </div>
                <div class="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div class="tk23-hkCont_premservs">
                      <span class="fontss" style={{ backgroundColor: "#fff" }}>
                        Premium Plan
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Whyglobal />
      </div>
    </>
  );
};

export default TapeBuy;
